import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {competencyById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {
  closeToCompetencyExecutiveDirectorById,
  closeToCompetencyFibcById,
  closeToCompetencySeniorCoachById,
} from '/redux/selector/metric.teams.selector';
import {withProps} from '/util/selector.util';

import CloseToCompetencySection from './CloseToCompetencySection';

const withCoachUserId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    currentUserCompetency: withCoachUserId(competencyById),
    executiveDirector: withCoachUserId(closeToCompetencyExecutiveDirectorById),
    fibc: withCoachUserId(closeToCompetencyFibcById),
    seniorCoach: withCoachUserId(closeToCompetencySeniorCoachById),
  }),
)(CloseToCompetencySection);
